import { render, staticRenderFns } from "./SchedaDetailModal.vue?vue&type=template&id=1ddcb688&scoped=true&"
import script from "./SchedaDetailModal.vue?vue&type=script&lang=js&"
export * from "./SchedaDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./SchedaDetailModal.vue?vue&type=style&index=0&id=1ddcb688&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddcb688",
  null
  
)

export default component.exports